export const BRANDING_LEVEL_1 = 1;
export const BRANDING_LEVEL_2 = 2;
export const BRANDING_LEVEL_3 = 3;
export const BRANDING_LEVEL_4 = 4;
